import { SyntheticEvent, useState } from 'react';
import { BaseAutocomplete } from '../../../BaseAutocomplete/BaseAutocomplete';
import { WebAutocompleteProps } from '../Autocomplete.types';

export const WebAutocomplete = <T,>({
    id,
    title,
    label,
    ariaLabel,
    labelClass,
    disabled,
    options,
    onOptionSelected,
    getOptionLabel,
    renderOption,
    forceBottomPopper,
    filterOptions,
    capsLock,
    fullWidth,
    seventyFivePercentWidth,
}: WebAutocompleteProps<T>) => {
    const [value, setValue] = useState<string>('');

    const handleOnChange = (event: SyntheticEvent<Element, Event>, value: string) => {
        onOptionSelected && onOptionSelected(value);
        setValue(value);
    };

    return (
        <BaseAutocomplete
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            labelClass={labelClass}
            inputValue={value}
            disabled={disabled}
            options={options}
            filterOptions={filterOptions}
            onOptionSelected={onOptionSelected}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            onInputChange={handleOnChange}
            forceBottomPopper={forceBottomPopper}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            freeSolo={true}
            openOnFocus={true}
        />
    );
};